import { render, staticRenderFns } from "./VehiculoRotativaSimulator.vue?vue&type=template&id=1546fb2d"
import script from "./VehiculoRotativaSimulator.vue?vue&type=script&lang=js"
export * from "./VehiculoRotativaSimulator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1546fb2d')) {
      api.createRecord('1546fb2d', component.options)
    } else {
      api.reload('1546fb2d', component.options)
    }
    module.hot.accept("./VehiculoRotativaSimulator.vue?vue&type=template&id=1546fb2d", function () {
      api.rerender('1546fb2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Simuladores/VehiculoRotativaSimulator.vue"
export default component.exports